import { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const PromotionalSMS = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 248 143"
        data-fill-none
      >
        <g clipPath="url(#clip0_1503_14916)">
          <rect
            width="248"
            height="143"
            rx="8"
            fill="#ECFEFF"
          />
          <path
            d="M59 67.6154C59 69.2271 59.6402 70.7728 60.7799 71.9124C61.9195 73.0521 63.4652 73.6923 65.0769 73.6923H89.3846L113.692 98V73.6923H125.846C127.458 73.6923 129.004 73.0521 130.143 71.9124C131.283 70.7728 131.923 69.2271 131.923 67.6154V25.0769C131.923 23.4652 131.283 21.9195 130.143 20.7799C129.004 19.6402 127.458 19 125.846 19H65.0769C63.4652 19 61.9195 19.6402 60.7799 20.7799C59.6402 21.9195 59 23.4652 59 25.0769V67.6154Z"
            fill="#E3E3E3"
          />
          <path
            d="M125.846 19H65.0769C63.4652 19 61.9195 19.6402 60.7799 20.7799C59.6402 21.9195 59 23.4652 59 25.0769V67.6154C59 69.2271 59.6402 70.7728 60.7799 71.9124C61.9195 73.0521 63.4652 73.6923 65.0769 73.6923H71.1538L125.846 19Z"
            fill="white"
          />
          <path
            d="M59 67.6154C59 69.2271 59.6402 70.7728 60.7799 71.9124C61.9195 73.0521 63.4652 73.6923 65.0769 73.6923H89.3846L113.692 98V73.6923H125.846C127.458 73.6923 129.004 73.0521 130.143 71.9124C131.283 70.7728 131.923 69.2271 131.923 67.6154V25.0769C131.923 23.4652 131.283 21.9195 130.143 20.7799C129.004 19.6402 127.458 19 125.846 19H65.0769C63.4652 19 61.9195 19.6402 60.7799 20.7799C59.6402 21.9195 59 23.4652 59 25.0769V67.6154Z"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M77.2308 47.8657C76.8279 47.8657 76.4415 47.7056 76.1566 47.4207C75.8716 47.1358 75.7116 46.7494 75.7116 46.3464C75.7116 45.9435 75.8716 45.5571 76.1566 45.2722C76.4415 44.9873 76.8279 44.8272 77.2308 44.8272"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <path
            d="M77.2308 47.8657C77.6337 47.8657 78.0201 47.7056 78.305 47.4207C78.59 47.1358 78.75 46.7494 78.75 46.3464C78.75 45.9435 78.59 45.5571 78.305 45.2722C78.0201 44.9873 77.6337 44.8272 77.2308 44.8272"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <path
            d="M95.4616 47.8657C95.0587 47.8657 94.6722 47.7056 94.3873 47.4207C94.1024 47.1358 93.9424 46.7494 93.9424 46.3464C93.9424 45.9435 94.1024 45.5571 94.3873 45.2722C94.6722 44.9873 95.0587 44.8272 95.4616 44.8272"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <path
            d="M95.4616 47.8657C95.8645 47.8657 96.2509 47.7056 96.5358 47.4207C96.8208 47.1358 96.9808 46.7494 96.9808 46.3464C96.9808 45.9435 96.8208 45.5571 96.5358 45.2722C96.2509 44.9873 95.8645 44.8272 95.4616 44.8272"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <path
            d="M113.692 47.8657C113.289 47.8657 112.903 47.7056 112.618 47.4207C112.333 47.1358 112.173 46.7494 112.173 46.3464C112.173 45.9435 112.333 45.5571 112.618 45.2722C112.903 44.9873 113.289 44.8272 113.692 44.8272"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <path
            d="M113.692 47.8657C114.095 47.8657 114.482 47.7056 114.767 47.4207C115.051 47.1358 115.212 46.7494 115.212 46.3464C115.212 45.9435 115.051 45.5571 114.767 45.2722C114.482 44.9873 114.095 44.8272 113.692 44.8272"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <path
            d="M150.806 69.4141H186.488V110.586H150.806V69.4141Z"
            fill="#66E1FF"
          />
          <path
            d="M186.488 105.022L150.88 69.4141H186.488V105.022Z"
            fill="#C2F3FF"
          />
          <path
            d="M186.488 116.076V110.586H150.806V116.076C150.81 117.53 151.39 118.924 152.419 119.952C153.447 120.981 154.841 121.561 156.295 121.565H180.999C182.453 121.561 183.847 120.981 184.876 119.952C185.904 118.924 186.484 117.53 186.488 116.076Z"
            fill="white"
          />
          <path
            d="M150.806 63.9245V69.414H186.488V63.9245C186.484 62.4699 185.904 61.0761 184.876 60.0475C183.847 59.019 182.453 58.4392 180.999 58.4349H156.295C154.841 58.4392 153.447 59.019 152.419 60.0475C151.39 61.0761 150.81 62.4699 150.806 63.9245Z"
            fill="white"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M128.848 94.1172H156.295C157.75 94.1215 159.144 94.7013 160.172 95.7298C161.201 96.7584 161.781 98.1522 161.785 99.6068V116.076C161.781 117.53 161.201 118.924 160.172 119.952C159.144 120.981 157.75 121.561 156.295 121.565H128.848C127.392 121.565 125.995 120.987 124.966 119.957C123.936 118.928 123.358 117.531 123.358 116.076V99.6068C123.358 98.1508 123.936 96.7545 124.966 95.7251C125.995 94.6956 127.392 94.1172 128.848 94.1172Z"
            fill="#FFEF5E"
          />
          <path
            d="M156.295 94.1172C157.75 94.1215 159.144 94.7013 160.172 95.7298C161.201 96.7584 161.781 98.1522 161.785 99.6068V116.076C161.783 116.834 161.622 117.583 161.314 118.276C161.006 118.969 160.557 119.59 159.995 120.099L134.013 94.1172H156.295Z"
            fill="#FFF9BF"
          />
          <path
            d="M150.806 88.6276V69.4141"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M123.358 99.6068V102.352H161.785V99.6068C161.781 98.1522 161.201 96.7584 160.172 95.7298C159.144 94.7013 157.75 94.1215 156.295 94.1172H128.848C127.392 94.1172 125.995 94.6956 124.966 95.7251C123.936 96.7545 123.358 98.1508 123.358 99.6068Z"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M123.358 102.352V116.076C123.358 117.531 123.936 118.928 124.966 119.957C125.995 120.987 127.392 121.565 128.848 121.565H156.295C157.75 121.561 159.144 120.981 160.172 119.952C161.201 118.924 161.781 117.53 161.785 116.076V102.352H123.358Z"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M186.488 69.4141V116.076C186.484 117.53 185.904 118.924 184.876 119.952C183.847 120.981 182.453 121.561 180.999 121.565H167.275"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M167.275 110.586H186.488"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M142.572 107.841H156.296"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M150.806 113.331H156.296"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_1503_14916">
            <rect
              width="248"
              height="143"
              rx="8"
              fill="white"
            />
          </clipPath>
        </defs>
      </SvgIcon>
    );
  })
);
